import React from 'react';

const messageHighlighter = val => {
  const liArr = [];
  const firstStr = val;
  const safeKey = () => Math.floor(Math.random() * 9999);
  recaller(firstStr);
  function recaller(str) {
    for (let i = 0; i < str.length; i++) {
      if (str[i] === '[' || str[i] === ':') {
        if (str.substr(i, 13) === '[Client Name]') {
          liArr.push(
            <span key={`s${safeKey()}${i}`} style={{ display: 'inline-block', whiteSpace: 'pre-wrap' }}>
              {str.substr(0, i)}
            </span>,
          );
          // liArr.push(<li style={{display: "inline-block",  whiteSpace: 'pre-wrap'}} className="blue">[Client Name]</li>)
          liArr.push(
            <span
              key={`s${safeKey()}${i}`}
              style={{ display: 'inline-block', whiteSpace: 'pre-wrap' }}
              className="blue"
            >
              [Client{' '}
            </span>,
          );
          liArr.push(
            <span
              key={`s${safeKey()}${i}`}
              style={{ display: 'inline-block', whiteSpace: 'pre-wrap' }}
              className="blue"
            >
              Name]
            </span>,
          );
          recaller(str.substr(i + 13));
          break;
        }
        if (str.substr(i, 6) === ':name:') {
          liArr.push(
            <span key={`s${safeKey()}${i}`} style={{ display: 'inline-block', whiteSpace: 'pre-wrap' }}>
              {str.substr(0, i)}
            </span>,
          );
          // liArr.push(<li style={{display: "inline-block",  whiteSpace: 'pre-wrap'}} className="blue">[Client Name]</li>)
          liArr.push(
            <span
              key={`s${safeKey()}${i}`}
              style={{ display: 'inline-block', whiteSpace: 'pre-wrap' }}
              className="blue"
            >
              [Client{' '}
            </span>,
          );
          liArr.push(
            <span
              key={`s${safeKey()}${i}`}
              style={{ display: 'inline-block', whiteSpace: 'pre-wrap' }}
              className="blue"
            >
              Name]
            </span>,
          );
          recaller(str.substr(i + 6));
          break;
        }
        if (str.substr(i, 13) === '[Review Link]') {
          liArr.push(
            <span key={`s${safeKey()}${i}`} style={{ display: 'inline-block', whiteSpace: 'pre-wrap' }}>
              {str.substr(0, i)}
            </span>,
          );
          // liArr.push(<li style={{display: "inline-block",  whiteSpace: 'pre-wrap'}} className="blue">[Review Link]</li>)
          liArr.push(
            <span
              key={`s${safeKey()}${i}`}
              style={{ display: 'inline-block', whiteSpace: 'pre-wrap' }}
              className="blue"
            >
              [Review{' '}
            </span>,
          );
          liArr.push(
            <span
              key={`s${safeKey()}${i}`}
              style={{ display: 'inline-block', whiteSpace: 'pre-wrap' }}
              className="blue"
            >
              Link]
            </span>,
          );
          recaller(str.substr(i + 13));
          break;
        }
        if (str.substr(i, 8) === ':review:') {
          liArr.push(
            <span key={`s${safeKey()}${i}`} style={{ display: 'inline-block', whiteSpace: 'pre-wrap' }}>
              {str.substr(0, i)}
            </span>,
          );
          // liArr.push(<li style={{display: "inline-block",  whiteSpace: 'pre-wrap'}} className="blue">[Review Link]</li>)
          liArr.push(
            <span
              key={`s${safeKey()}${i}`}
              style={{ display: 'inline-block', whiteSpace: 'pre-wrap' }}
              className="blue"
            >
              [Review{' '}
            </span>,
          );
          liArr.push(
            <span
              key={`s${safeKey()}${i}`}
              style={{ display: 'inline-block', whiteSpace: 'pre-wrap' }}
              className="blue"
            >
              Link]
            </span>,
          );
          recaller(str.substr(i + 8));
          break;
        }
        if (str.substr(i, 16) === '[Associate Name]') {
          liArr.push(
            <span key={`s${safeKey()}${i}`} style={{ display: 'inline-block', whiteSpace: 'pre-wrap' }}>
              {str.substr(0, i)}
            </span>,
          );
          // liArr.push(<li style={{display: "inline-block",  whiteSpace: 'pre-wrap'}} className="blue">[Associate Name]</li>)
          liArr.push(
            <span
              key={`s${safeKey()}${i}`}
              style={{ display: 'inline-block', whiteSpace: 'pre-wrap' }}
              className="blue"
            >
              [Associate{' '}
            </span>,
          );
          liArr.push(
            <span
              key={`s${safeKey()}${i}`}
              style={{ display: 'inline-block', whiteSpace: 'pre-wrap' }}
              className="blue"
            >
              Name]
            </span>,
          );
          recaller(str.substr(i + 16));
          break;
        }
        if (str.substr(i, 11) === ':associate:') {
          liArr.push(
            <span key={`s${safeKey()}${i}`} style={{ display: 'inline-block', whiteSpace: 'pre-wrap' }}>
              {str.substr(0, i)}
            </span>,
          );
          // liArr.push(<li style={{display: "inline-block",  whiteSpace: 'pre-wrap'}} className="blue">[Associate Name]</li>)
          liArr.push(
            <span
              key={`s${safeKey()}${i}`}
              style={{ display: 'inline-block', whiteSpace: 'pre-wrap' }}
              className="blue"
            >
              [Associate{' '}
            </span>,
          );
          liArr.push(
            <span
              key={`s${safeKey()}${i}`}
              style={{ display: 'inline-block', whiteSpace: 'pre-wrap' }}
              className="blue"
            >
              Name]
            </span>,
          );
          recaller(str.substr(i + 11));
          break;
        }
      } else if (str[i] === ' ') {
        liArr.push(
          <span key={`s${safeKey()}${i}`} style={{ display: 'inline-block', whiteSpace: 'pre-wrap' }}>
            {str.substr(0, i + 1)}
          </span>,
        );
        // liArr.push(<li style={{display: "inline-block",  whiteSpace: 'pre-wrap'}}>{" "}</li>)
        recaller(str.substr(i + 1));
        break;
      } else if (!str[i + 1]) {
        liArr.push(
          <span key={`s${safeKey()}${i}`} style={{ display: 'inline-block', whiteSpace: 'pre-wrap' }}>
            {str}
          </span>,
        );
      }
    }
  }
  return liArr;
};
export default messageHighlighter;
